import { loginPI, getUserInfoAPI } from '@/api/user.js'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { constRoutes, asyncRoutes } from '@/router/index.js'
import router from '@/router/index.js'
const computeAsyncRoutes = (oriAsyncRoutes, authMenus = []) => {
  const res = oriAsyncRoutes.filter(item => {
    if (authMenus.indexOf(item.name) != -1) {
      if (item.children && item.children.length > 0) {
        item.children = computeAsyncRoutes(item.children, authMenus)
      }
      return true
    }
  })
  return res
}
export default {
  namespaced: true,
  state: {
    token: getToken() || '',
    userInfo: {},
    isAdmin: 0,
    authMenus: []
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    UPDATE_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    UPDATE_AUTHMENUS(state, authMenus) {
      state.authMenus = authMenus
    }
  },
  actions: {
    async login({ commit, dispatch }, data) {
      const { token } = await loginPI(data)
      const isAdmin = 0
      const authMenus = []
      commit('SET_TOKEN', token)
      commit('UPDATE_AUTHMENUS', authMenus)
    },
    logout({ commit }, val) {
      commit('SET_TOKEN', val)
      commit('UPDATE_USERINFO', {})
      removeToken()
    },
    async getUserInfo({ commit }) {
      const res = await getUserInfoAPI()
      commit('UPDATE_USERINFO', res.data)
    }
  },
  getters: {
    getResultRoutes(state) {
      const calAsyncRoutes = state.isAdmin ? asyncRoutes() : computeAsyncRoutes(asyncRoutes(), state.authMenus)
      let res = constRoutes.concat(calAsyncRoutes)
      // res.forEach(item => {
      //   if (item.children && item.children.length > 0) {
      //     for (let i = 0; i < item.children.length; i++) {
      //       if (item.children[i].meta && !item.children[i].meta.hidden) {
      //         item.redirect = item.children[i].path
      //         break
      //       }
      //     }
      //   }
      // })
      router.addRoutes(res)
      return res
    }
  }
}
